export default __webpack_public_path__ + "e2ed0ba4d854f0fa64064c73b17b15bf.png";